import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import { TOAST_PROPERTIES, TOAST_POSITION, TRANSLATION_OF_ROUTES, rowsPerPage, BREAKPOINTS } from '@global/constants'
import {
  WrapperLoading,
  FilterContainer,
  FilterContainerLeftSide,
  FilterContainerRightSide,
  WrapperHeading,
  TableWrapper,
  PaginationWrapper
} from '@global/styles'

import {
  TOKEN_HELPERS,
  sortByKey,
  filterBodyBuilder,
  handleClickPaginationItem,
  filterOrderBuilder
} from '@utils/helpers'

import { SITE } from '@routes/paths'
import { MESSAGES } from '@global/message'
import { spacing } from '@global/theme'

import { Heading } from '@components/texts'
import { GhostButton } from '@components/button'

import { useWindowDimensions } from '@components/windowDimensions'
import Table from '@components/table'
import Toast from '@components/toast'
import Modal from '@components/modal'
import { useUser } from '@components/authentication/utils/hook'
import Filter from '@components/filter'
import Badge from '@components/badge'
import BadgeGroup from '@components/badgeGroup'
import SearchBar from '@components/searchBar'
import PaginationGroup from '@components/paginationGroup'
import Loading from '@components/loading'

import SELECTORS_USER from '@components/authentication/redux/selectors'
import useRedux from './redux'
import { PEOPLE_ACTIONS } from './redux/actions'
import SELECTORS from './redux/selectors'
import { columnData } from './data'
import AddPersonModal from './components/addPersonModal'
import { Wrapper } from './styles'

const People = () => {
  useRedux()
  const { GetToken, Logout } = useUser()
  const dispatch = useDispatch()
  const history = useHistory()
  const { key } = useLocation()
  const { device, deviceName } = useWindowDimensions()

  const [currentToken] = useState(GetToken())
  const [itemSelected, setItemSelected] = useState()
  const [selectedOption, setSelectedOption] = useState(rowsPerPage[0])
  const [pages, setPages] = useState()
  const [totalItems, setTotalItems] = useState(0)
  const [tablelist, setTablelist] = useState([])
  const [columns, setColumns] = useState([])
  const [isShowing, setIsShowing] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [messageToast, setMessageToast] = useState({
    title: '',
    message: '',
    icon: '',
    color: ''
  })
  const [badges, setBadges] = useState([])
  const [filterData, setFilterData] = useState([])
  const [open, setOpen] = useState(false)
  const [activeFilters, setActiveFilters] = useState(null)
  const [addPersonModal, setAddPersonModal] = useState()
  const [errorFlag, setErrorFlag] = useState(false)
  const [parameters, setParameters] = useState()

  const loading = useSelector(SELECTORS.LOADING)
  const peopleLoading = useSelector(SELECTORS.LOADING_LIST)
  const totalPages = useSelector(SELECTORS.PAGES)
  const items = useSelector(SELECTORS.SUCCESS)
  const fields = useSelector(SELECTORS.COLUMNS)
  const allItems = useSelector(SELECTORS.TOTAL_ITEMS)
  const errorMessage = useSelector(SELECTORS.ERROR)
  const filterObject = useSelector(SELECTORS.FILTER_OBJECT)
  const personStatus = useSelector(SELECTORS.PERSON_STATUS)
  const errorRefresh = useSelector(SELECTORS_USER.ERROR_USER_REFRESH)

  const getPeople = body => {
    const { token, tokenCreationDate } = currentToken
    const { isValid, error } = TOKEN_HELPERS.IS_VALID_TOKEN(tokenCreationDate)
    if (isValid) {
      dispatch(PEOPLE_ACTIONS.GET({ data: body, token }))
    } else TOKEN_HELPERS.EXPIRED_TOKEN(error, setIsShowing, setMessageToast, Logout)
  }

  const getPerson = id => {
    history.push(`${SITE.PEOPLE}${SITE.PERSON}/${id}`)
  }

  const customHeaderDataTable = (headersData, colData) => {
    const orderedColumns = sortByKey(headersData, 'order').map(col => col.name)
    let customColumns = []
    for (let i = 0; i < orderedColumns.length; i++) {
      const wanted = Object.entries(colData).find(item => item[0] === orderedColumns[i])
      if (wanted) {
        customColumns = [
          ...customColumns,
          wanted[1]
        ]
      }
    }

    return customColumns
  }

  const customBodyDataTable = bodyData => {
    const newData = bodyData.map(item => {
      const { affiliateStatusName, frmStatusName, employmentStatusName } = item
      let newItem = item
      const affiliateBadge = (
        <Badge
          text={affiliateStatusName}
          color='system'
          backgroundColor='secondary'
          size='small'
        />
      )
      const frmBadge = (
        <Badge
          text={frmStatusName}
          color='system'
          backgroundColor='secondary'
          size='small'
        />
      )
      const employmentBadge = (
        <Badge
          text={employmentStatusName}
          color='system'
          backgroundColor='secondary'
          size='small'
        />
      )

      newItem = {
        id: item.id,
        billingNumber: item.billingNumber,
        fullName: item.fullName,
        ci: item.ci,
        affiliateStatusName: affiliateStatusName ? affiliateBadge : '',
        affiliateCategoryName: item.affiliateCategoryName,
        affiliateDate: item.affiliateDate,
        frmStatusName: frmStatusName ? frmBadge : '',
        employmentStatusName: employmentStatusName ? employmentBadge : '',
        personStatus: personStatus.find(s => s.id === item.personStatusId).name || item.personStatusName,
        bmsInbound: item.bmsInbound?.toFixed(2) || 'N/A',
        bmsOutbound: item.bmsOutbound?.toFixed(2) || 'N/A',
        bmsBonusCoefficient: item.bmsBonusCoefficient?.toFixed(2) || 'N/A',
        bmsAvailable: item.bmsAvailable?.toFixed(2) || 'N/A'
      }
      return newItem
    })
    return newData
  }

  const handleOrderChange = (nameColumn, typeOrder) => {
    const colNames = Object.entries(columnData).find(col => col[1].name === nameColumn)[0]
    const propsForOrderBuilder = {
      filterState: activeFilters,
      setFilterState: setActiveFilters,
      columnName: colNames,
      orderByDesc: typeOrder,
      currentPageSize: selectedOption.value,
      currentPageNumber: itemSelected,
      setNewItemSelected: setItemSelected
    }
    const body = filterOrderBuilder(propsForOrderBuilder)
    getPeople(body)
  }

  const handleDropdownChange = e => {
    let body = null
    if (activeFilters) {
      body = { ...activeFilters }
      body = {
        ...body,
        pageNumber: 1,
        pageSize: e.value.value
      }
      setActiveFilters(body)
    } else {
      body = {
        pageNumber: 1,
        pageSize: e.value.value
      }
    }

    getPeople(body)
    setSelectedOption(e.value)
    setItemSelected(0)
  }

  const handleInputChange = e => {
    if (!e?.value) delete activeFilters.filterText

    let body = activeFilters ? { ...activeFilters } : {}

    if (e?.value) {
      body = { ...body, filterText: e.value }
      setActiveFilters({
        ...activeFilters,
        filterText: e.value
      })
    }
    getPeople(body)
  }

  const handleClickShowFilters = () => {
    const { token, tokenCreationDate } = currentToken
    const { isValid, error } = TOKEN_HELPERS.IS_VALID_TOKEN(tokenCreationDate)
    if (isValid) {
      const filterRequest = { id: 1, token }
      dispatch(PEOPLE_ACTIONS.GET_FILTER_DATA(filterRequest))
      setShowFilter(!showFilter)
    } else TOKEN_HELPERS.EXPIRED_TOKEN(error, setIsShowing, setMessageToast, Logout)
  }

  const handleClickCloseFilters = () => {
    dispatch(PEOPLE_ACTIONS.FILTER_DATA_CLEAR())
    setShowFilter(!showFilter)
  }

  const handleAddDataPerson = () => {
    setIsShowing(true)
    setMessageToast({
      title: TOAST_PROPERTIES.SUCCESS.title,
      message: MESSAGES.SUCCESSFULLY_CREATED_PERSON,
      icon: TOAST_PROPERTIES.SUCCESS.icon,
      color: TOAST_PROPERTIES.SUCCESS.color
    })
    const body = {
      pageNumber: 1,
      pageSize: selectedOption.value,
      orderByColumn: 'BillingNumber',
      orderByDesc: false
    }
    getPeople(body)
  }

  const handleToastClose = () => setIsShowing(false)

  const handleRowClick = rowObj => getPerson(rowObj.id)

  const handleCloseBadge = filterName => {
    const updateBadges = badges.filter(badge => badge.name !== filterName)
    setBadges(updateBadges)
    const body = filterBodyBuilder(updateBadges, selectedOption.value, setActiveFilters, activeFilters, parameters)
    getPeople(body)
  }

  const handleApplyFilter = filters => {
    setBadges(filters)
    const body = filterBodyBuilder(filters, selectedOption.value, setActiveFilters, activeFilters, parameters)
    getPeople(body)
  }

  const handleCloseModal = () => {
    setAddPersonModal(null)
    setOpen(false)
  }

  const handleClickAddPerson = () => {
    setAddPersonModal({
      close: handleCloseModal,
      saveData: handleAddDataPerson,
      currentToken
    })
    setOpen(true)
  }

  const renderTable = values => {
    const { currentList, columnsN, currentLoading, handleOrder, handleSelectedRow, error, showRowPointer } = values
    return (
      <Table
        list={currentList}
        columns={columnsN}
        loading={currentLoading}
        handleOrder={handleOrder}
        rowClick={handleSelectedRow}
        error={error}
        showRowPointer={showRowPointer}
      />
    )
  }

  const renderFilter = arrFilters => (
    <Filter
      device={device}
      close={handleClickCloseFilters}
      loadBadges={handleApplyFilter}
      filterData={arrFilters}
      isShowing={showFilter}
    />
  )

  useEffect(() => {
    dispatch(PEOPLE_ACTIONS.CLEAR())
    const body = {
      pageNumber: 1,
      pageSize: selectedOption.value,
      orderByColumn: 'BillingNumber',
      orderByDesc: false
    }
    setActiveFilters(body)
    getPeople(body)
  }, [key])

  useEffect(() => {
    setTablelist(customBodyDataTable(items))
    setColumns(customHeaderDataTable(fields, columnData))
    setPages(totalPages.totalPages)
    setItemSelected(totalPages.currentPage - 1)
    setTotalItems(allItems)
  }, [items, totalPages])

  useEffect(() => {
    if (errorMessage) {
      setMessageToast({
        title: TOAST_PROPERTIES.ERROR.title,
        message: errorMessage.message || `Error ${errorMessage.status}`,
        icon: TOAST_PROPERTIES.ERROR.icon,
        color: TOAST_PROPERTIES.ERROR.color
      })
      setIsShowing(true)
      if (!errorFlag) {
        const body = {
          pageNumber: 1,
          pageSize: selectedOption.value,
          orderByColumn: 'BillingNumber',
          orderByDesc: false
        }
        getPeople(body)
        setErrorFlag(true)
      } else {
        setTimeout(() => {
          history.goBack()
        }, 1500)
      }
    }
  }, [errorMessage])

  useEffect(() => {
    if (filterObject.length > 0) {
      setFilterData(filterObject)
      setParameters(filterObject.map(p => p.name))
    }
  }, [filterObject])

  useEffect(() => {
    if (errorRefresh) {
      TOKEN_HELPERS.EXPIRED_TOKEN(MESSAGES.EXPIRED_TOKEN, setIsShowing, setMessageToast, Logout)
    }
  }, [errorRefresh])

  return (
    <>
      {loading
        ? (
          <WrapperLoading>
            <Loading color='primary' size='xsmall' weight='bold' />
          </WrapperLoading>
        )
        : (
          <Wrapper>
            <WrapperHeading columnStart='1' columnEnd='12' rowStart='2' rowEnd='2'>
              <Heading
                type='h2'
                weight='bold'
                align='left'
              >
                {TRANSLATION_OF_ROUTES.PEOPLE}
              </Heading>
            </WrapperHeading>
            <FilterContainer
              columnStart={1}
              columnEnd={12}
              rowStart={3}
              rowEnd={3}
              deviceName={deviceName}
            >
              <FilterContainerLeftSide deviceName={deviceName}>
                <GhostButton
                  color='tertiary'
                  size='small'
                  text='Agregar Filtro'
                  icon='filter_alt'
                  onClick={handleClickShowFilters}
                />
                {badges.length > 0 && <BadgeGroup badges={badges} handleCloseBadge={handleCloseBadge} />}
                {showFilter && (filterData.length > 0 && renderFilter(filterData))}
              </FilterContainerLeftSide>
              <FilterContainerRightSide deviceName={deviceName}>
                <SearchBar onChange={handleInputChange} value={activeFilters.filterText} />
                <GhostButton
                  color='tertiary'
                  size='small'
                  text='Agregar Persona'
                  icon='add'
                  onClick={handleClickAddPerson}
                />
              </FilterContainerRightSide>
            </FilterContainer>
            <TableWrapper rowStart='4' rowEnd='4' columnStart='1' columnEnd='12'>
              {renderTable({
                currentList: tablelist,
                columnsN: columns,
                currentLoading: peopleLoading,
                handleOrder: handleOrderChange,
                handleSelectedRow: handleRowClick,
                error: !!errorMessage,
                showRowPointer: true
              })}
            </TableWrapper>
            <PaginationWrapper
              rowStart='5'
              rowEnd='5'
              columnStart='1'
              columnEnd='12'
            >
              {tablelist.length > 0
              && (
              <PaginationGroup
                deviceName={deviceName}
                pages={pages}
                itemSelected={itemSelected}
                handleClickPaginationItem={n => handleClickPaginationItem(
                  n, activeFilters, selectedOption.value, getPeople, setItemSelected
                )}
                options={rowsPerPage}
                selectedOption={selectedOption}
                handleDropdownChange={handleDropdownChange}
                totalItems={totalItems}
                itemsPerPage={tablelist.length}
              />
              )}
            </PaginationWrapper>
            <Toast
              title={messageToast.title}
              message={messageToast.message}
              color={messageToast.color}
              icon={messageToast.icon}
              isShowing={isShowing}
              position={TOAST_POSITION.rightTop}
              onClick={handleToastClose}
              timeOut={2000}
            />
            <Modal
              isShowing={open}
              close={handleCloseModal}
              title='Agregar Persona'
              minHeight='380px'
              padding={device === BREAKPOINTS.MOBILE ? spacing.one : spacing.four}
            >
              {addPersonModal && <AddPersonModal {...addPersonModal} />}
            </Modal>
          </Wrapper>
        )}
    </>
  )
}

export default People
